import { useCallback, useState } from 'react';

//
//

export const useToggle = (defaultValue = false) => {
  const [value, setValue] = useState(defaultValue);

  const _setValue = useCallback((val) => setValue(val), []);

  return {
    value,
    toggle: () => setValue(v => !v),
    on: () => setValue(true),
    off: () => setValue(false),
    setValue: _setValue,
    preventEventDefault: event => event?.preventDefault?.(),
  };
};